import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { flex } from 'src/styles/utils';
import {
  InitialLoadIconsSet,
  OtherIconsSet
} from 'src/utils/constants/IconsConstants';

import {
  getInitialLoadIcons,
  getOtherIcons,
  ZeeFontMedium,
  ZeeFontRegular
} from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const railsTitle = css`
  color: ${colors.PrimaryWhiteColor};
  margin: 16px 10px 16px 0;
  ${ZeeFontMedium(16)}
  ${MQ.MediaLg} {
    ${ZeeFontMedium(21)}
  }
`;

export const moreLinkContainer = css`
  margin: 16px 0 16px auto;
`;

export const railsContainer = (displayContent = 'inline-block') => css`
  width: 100%;
  padding-bottom: 16px;
  display: ${displayContent};
  ${MQ.MediaLg} {
    &:hover {
      & .arrow-btn {
        opacity: 1;
        z-index: 100;
      }
    }
  }
`;

export const railsHeaderStyle = css`
  ${flex('row', 'space-between')};
`;

export const moreLinkStyle = css`
  ${ZeeFontRegular(14, 16)};
  ${getInitialLoadIcons(InitialLoadIconsSet.VIEW_ALL, true)};
  color: ${colors.PurpleLight};
  cursor: pointer;
  ${flex()};
  &:after {
    margin-left: 5px;
  }
`;

export const railsTitleContainer = css`
  ${flex('column', 'center', 'flex-start')};
`;

export const informationStyle = css`
  ${ZeeFontMedium(16)};
  color: ${colors.AnchorTagColor};
  ${getOtherIcons(OtherIconsSet.INFO)};
  padding: 6px 5px 0;
  cursor: pointer;
  ${MQ.MediaLg} {
    ${ZeeFontMedium(21)};
  }
`;
export const moreOnly = css`
  ${flex('row', 'flex-end')};
  margin-top: -60px;
  margin-bottom: 30px;
`;
